import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';

import FormCargarNovedad from './FormCargarNovedad';
import insertNovedad from '../../../graphql/mutations/rrhh/insertNovedad.graphql';
import getNovedades from '../../../graphql/querys/rrhh/getNovedades.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

@compose(
  graphql(insertNovedad, {
    name: 'insertNovedad',
    options: {
      refetchQueries: [{ query: getNovedades }],
    },
  }),
  graphql(getUsuario)
)
class CargarNovedad extends React.Component {
  onSubmit = values => {
    const { idUsuarios, ...rest } = values;
    const baseObj = {
      ...rest,
      fechaDesde: values.fechaDesde.toDate(),
      fechaHasta: values.fechaHasta.toDate(),
      idOrganismo: this.props.data.getUsuario.organismo._id,
    };

    const inserts = idUsuarios.map(idUsuario =>
      this.props.insertNovedad({
        variables: {
          objNovedad: { ...baseObj, idUsuario },
        },
      })
    );

    Promise.all(inserts)
      .then(() => {
        notification.success({
          message: 'Novedades Registradas',
          description: `Se registraron ${idUsuarios.length} novedad(es) correctamente.`,
        });
        this.props.history.push('/rrhh/novedades');
      })
      .catch(err => {
        console.log('Existio un error a la hora de crear la novedad');
        console.log(err);

        Modal.error({
          title: 'Error en la creación de la novedad',
          content:
            'Lamentamos informarle que la operación que intentó realizar, no se llevó a cabo por un error interno. Si el error persiste, comuníquese con el departamento de informática para obtener más detalles.',
        });
      });
  };

  render() {
    return (
      <div>
        <br />
        <FormCargarNovedad
          history={this.props.history}
          onSubmit={this.onSubmit}
        />
      </div>
    );
  }
}

export default withApollo(CargarNovedad);
